import { Outlet } from 'react-router';
import FrontendLayout from '@/components/layout/FrontendLayout';

export function ViewLayoutRoute() {
    return (
        <FrontendLayout frontend="view">
            <Outlet />
        </FrontendLayout>
    );
}
